export default __webpack_public_path__ + "static/warehouse-bg-4630dce7817fda2c56130b0bee91e9c7.jpg";